import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { channelOptions, contentReviewStatusOptions } from '../../../constants/';
import { formatDateString, displayText } from 'utils';
import * as api from 'api';
import * as Permissions from 'constants/permissions';
import ChatList from './chat-list';
import ChatReviewForm from './chat-review-form';
import './index.css';
const ContentDetail = () => {
	const navigate = useNavigate();

	const { state } = useLocation();
	const { sessionId } = useParams();
	const { permissions } = useSelector((state) => state.user);

	const [conversationBasicInfo, setConversationBasicInfo] = useState([]);
	const [qaPairs, setQAPairs] = useState([]);
	// const [selectedChat, setSelectedChat] = useState(null);
	const [selectedIndex, setSelectedIndex] = useState(-1);

	useEffect(() => {
		if (sessionId) {
			getConversationData(sessionId);
		}
	}, [sessionId]);

	// MARK: - api calls
	function getQAPairs(chatHistory) {
		const output = [];
		const qaPair = {
			question: '',
			answer: '',
		};
		chatHistory.forEach((element, idx) => {
			if (idx % 2 === 0) {
				qaPair.question = element;
			} else {
				qaPair.answer = element;
				output.push({ ...qaPair });
			}
		});
		return output;
	}

	async function getConversationData(sessionId) {
		try {
			const response = await api.getConversationData(sessionId);
			const qaPairs = getQAPairs(response?.list ?? []);
			setQAPairs(qaPairs);
			if (qaPairs.length > 0 && selectedIndex < 0) {
				setSelectedIndex(0);
			}
			const channelOpt = channelOptions.filter((option) => option.value === state.channel);
			const basicInfo = [
				{
					label: 'Channel',
					value: displayText(channelOpt[0].label),
				},
				{
					label: 'User ID',
					value: displayText(state.userId),
				},
				{
					label: 'User IP',
					value: displayText(state.ip),
				},
				{
					label: 'Status',
					value: displayText(contentReviewStatusOptions.filter((opt) => opt.value === response.status)[0]['label']),
				},
				{ label: 'Editor', value: displayText(response.reviewedBy) },
				{ label: 'Update Time', value: formatDateString(response.reviewedAt) },
			];

			setConversationBasicInfo(basicInfo);
		} catch (error) {
			console.error('Fail to get conversation data:', error);
		} finally {
		}
	}

	return (
		<div className="app-page-container">
			<div className="app-navbar">
				<div className="app-navbar-text">Content Detail</div>
				<div className="page-actions">
					<div
						className="app-btn app-btn-edit app-btn-padding app-btn-min-width"
						onClick={() => navigate('/guardrail/content-review')}
					>
						Back
					</div>
				</div>
			</div>
			<div className="conversation-basic-info-section">
				{conversationBasicInfo.map((item, index) => (
					<div key={`basic-info-${index}`} className="conversation-basic-info-piece">
						<div className="conversation-basic-info-title">{item.label}</div>
						<div className="conversation-basic-info-value">{item.value}</div>
					</div>
				))}
			</div>
			<div className="conversation-review-section">
				<ChatList qaPairs={qaPairs} onChatSelected={(index) => setSelectedIndex(index)} selectedIndex={selectedIndex} />
				{permissions.includes(Permissions.ContentReview_APPROVE) && (
					<ChatReviewForm chat={qaPairs[selectedIndex]} onFormSubmitted={() => getConversationData(sessionId)} />
				)}
			</div>
		</div>
	);
};

export default ContentDetail;
